import { render, staticRenderFns } from "./IconPackages.vue?vue&type=template&id=6b9c673c&"
import script from "./IconPackages.vue?vue&type=script&lang=js&"
export * from "./IconPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports